@if ({
  logo: ui.getLogoImage() | async
  }; as _) {
  <div id="logo-container" [ngStyle]="customStyle">
    <img [src]="_.logo" [alt]="'logo'">
  </div>
}
